import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import { setTimer } from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'TIMER_CHANGE': {
      return setTimer(state, action.payload);
    }

    default:
      return state;
  }
}
